import fonts from '../../data/mock/icon/icon';

/**
 * 拓扑插件-处理字体图标
 */

/**
 * 拓扑插件-转换图标 Unicode 码格式
 */
const icons = fonts.glyphs.map((icon) => {
  return {
    name: icon.name,
    // `\\u${icon.unicode}`,
    unicode: String.fromCodePoint(icon['unicode_decimal'])
  };
});


/**
 * 拓扑插件-根据图标名称获取字体图标 Unicode 码
 * @param name
 * @returns {string}
 */
export function getIcon(name) {
  const matchIcon = icons.find(icon => getPrefix(icon.name) === name) || { unicode: '', name: 'default' };
  return matchIcon.unicode;
}


/**
 * 拓扑插件-根据字体库前缀拼接图标名称
 * @param name 图标名称
 * @returns name 完整图标名称
 */
export function getPrefix(name) {
  return fonts.css_prefix_text + name;
}
